import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  openPanelButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    zIndex: 100,
    width: 30,
    height: 30,
    fontSize: 16,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.light + '3F',
  },
  cadPanelWrapper: {
    width: '800px',
    maxHeight: 'calc(100vh - 120px)',
    background: theme.palette.background.mainNested,
    padding: '4px 20px 20px',
    overflow: 'auto',
    ...theme.mixins.scrollbar,
  },
  cadHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navContextName: {
    position: 'absolute',
    top: 75,
    left: '50%',
    transform: 'translateX(-50%)',
  },
}));

export default useStyles;
